import { map } from 'rxjs';
import { activeStudentsAndTeachersList } from '../../../graphql/queries/activeStudentsAndTeachersList.query';
import { engagementBySchools } from '../../../graphql/queries/engagementBySchools.query';
import { lastExecutedTime } from '../../../graphql/queries/lastExecutedTime.query';
import { standardsPerformanceByPrograms } from '../../../graphql/queries/standardsPerformanceByPrograms.query';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/apollo-service/apollo.service";
export class RealizeOverviewDataService {
    constructor(apolloService) {
        this.apolloService = apolloService;
    }
    getActiveStudentsAndTeachersData() {
        return this.apolloService
            .query({
            query: activeStudentsAndTeachersList,
        })
            .pipe(map(({ data }) => data));
    }
    getEngagementBySchools(input) {
        return this.apolloService
            .query({
            query: engagementBySchools,
            variables: input,
        })
            .pipe(map(({ data }) => data));
    }
    getLastExecutedTime() {
        return this.apolloService
            .query({
            query: lastExecutedTime,
        })
            .pipe(map(({ data }) => data));
    }
    getStandardsPerformanceByPrograms(input) {
        return this.apolloService
            .query({
            query: standardsPerformanceByPrograms,
            variables: input,
        })
            .pipe(map(({ data }) => data));
    }
}
RealizeOverviewDataService.ɵfac = function RealizeOverviewDataService_Factory(t) { return new (t || RealizeOverviewDataService)(i0.ɵɵinject(i1.ApolloService)); };
RealizeOverviewDataService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RealizeOverviewDataService, factory: RealizeOverviewDataService.ɵfac, providedIn: 'root' });
